import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { GeoArea } from '@/types/GeoArea';
import { ReactNode } from 'react';

export function getPageDescriptionFromGeoArea(geoArea: GeoArea | undefined): ReactNode {
    // Geo area has a custom description
    if (geoArea?.description) {
        return geoArea.description;
    }

    // Geo area has a page title, use it in the localized description
    if (geoArea?.pageTitle) {
        return (
            <FormattedMessage
                id="auctionsNearMe.locationPageDescription"
                values={{
                    location: geoArea.pageTitle,
                }}
            />
        );
    }

    // Default page description
    return <FormattedMessage id="auctionsNearMe.defaultPageDescription" />;
}
